module.exports = __webpack_public_path__ + "img/endone.5dd91ce5.png";